<template>
  <div class="m-market-range">
    <div class="market-range-bar">
      <MarketProgress
        v-if="visible"
        :total="scaleNum || total"
        :start-index="progressRange[0]"
        :end-index="progressRange[1]"
        :has-scales="hasScales"
        @change="onChangeRange"
      />
    </div>

    <div class="outcome-wrap">
      <template v-if="market && currentOutcome.id">
        <!-- 加 key 避免 outcome odds 在切换时发生变化 -->
        <Outcome
          :key="`${market.id}-${currentOutcome.id}`"
          :outcome="currentOutcome"
          :market="market"
          :event="event"
        />
      </template>

      <Outcome
        v-else
        :disabled="true"
      />
    </div>
  </div>
</template>

<script>
/**
 * 8、多个 market 范围比分显示, 如 goals range
 */
import Outcome from 'wap/match/Event/pagelet/Outcome'
import MarketProgress from 'wap/match/MarketProgress'

export default {
  name: 'Market8Range',
  components: {
    Outcome,
    MarketProgress
  },
  props: {
    market: {
      type: Object,
      default: () => null
    },
    event: {
      type: Object,
      default: () => ({})
    },
    // 是否显示刻度
    hasScales: {
      type: Boolean,
      default: true
    },
    // 刻度数
    scaleNum: {
      type: Number,
      default: 0
    },
    // 是否需要筛选 odds
    oddsfiltered: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentOutcome: {},
      // 有多少刻度
      total: 6
    }
  },
  computed: {
    progressRange() {
      if (!this.currentOutcome.id) return [0, 1]
      let [startIndex, endIndex] = this.currentOutcome.id.match(/(\d+)/g)
      if (!endIndex) endIndex = startIndex
      return [+startIndex, +endIndex || 0]
    }
  },
  created() {
    if (this.market) {
      this.init()
      this.$watch('market.id', () => {
        this.init()
      })
    }
  },
  methods: {
    init() {
      this.setDefaultOutcome()
      this.updateScaleNum()
    },
    updateScaleNum() {
      if (this.scaleNum) return this.scaleNum
      // 比赛详情页靠自己解析
      let maxNumOutcomeId
      const { outcomes } = this.market
      if (Array.isArray(outcomes)) {
        maxNumOutcomeId = outcomes.find((x) => /^\d\+/.test(x))
      } else {
        maxNumOutcomeId = outcomes.order.find((x) => /^\d\+/.test(x))
      }
      if (maxNumOutcomeId) {
        this.total = parseInt(maxNumOutcomeId, 10) + 1
      }
    },
    setDefaultOutcome() {
      const { oddsfiltered } = this
      const { outcomes } = this.market
      if (Array.isArray(outcomes)) {
        let firstActiveId
        for (let i = 0; i < outcomes.length; i++) {
          const outcome = outcomes[i]
          const { id } = outcome
          if (outcome.isActive) {
            // 如果有筛选 odds 的话，直接选择第一个可投的值（后端已做排序）。然后，优先判断范围可投，如果都没有，则选择第一个可投的值
            if (oddsfiltered || /-/.test(id)) {
              firstActiveId = id
              this.currentOutcome = outcome
              break
            } else {
              if (!firstActiveId) {
                firstActiveId = id
                this.currentOutcome = outcome
              }
            }
          }
        }
      } else {
        let firstActiveId
        const outcomeMap = outcomes.map
        for (let i = 0; i < outcomes.order.length; i++) {
          const id = outcomes.order[i]
          if (outcomeMap[id].isActive) {
            // 如果有筛选 odds 的话，直接选择第一个可投的值（后端已做排序）。然后，优先判断范围可投，如果都没有，则选择第一个可投的值
            if (oddsfiltered || /-/.test(id)) {
              firstActiveId = id
              break
            } else {
              if (!firstActiveId) {
                firstActiveId = id
              }
            }
          }
        }
        if (firstActiveId) {
          this.currentOutcome = outcomes.map[firstActiveId]
        }
      }
    },
    onChangeRange([start, end]) {
      if (!this.market) return
      const key = start === end ? `${start}` : `${start}-${end}`
      const { outcomes } = this.market
      if (Array.isArray(outcomes)) {
        this.currentOutcome = outcomes.find((x) => x.id === key || x.id === `${key}+`) || {}
      } else {
        this.currentOutcome = outcomes.map[key] || outcomes.map[`${key}+`]
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-market-range {
  display: flex;
  align-items: center;
  justify-content: center;

  .market-range-bar {
    flex: 2;
    margin-right: 11/@rem;
  }

  .outcome-wrap {
    flex: 1;
  }

  .m-outcome {
    width: 100%;
    height: 36/@rem;
    border-radius: 4/@rem;
    margin-bottom: 4/@rem;
    line-height: 36/@rem;
    text-align: center;
  }
}
</style>
